module.exports = __webpack_public_path__ + "files/b11620b2b398b4332b706bc4990ac6ff.png";